import { Action, createReducer, on } from '@ngrx/store';
import { fromProductRetirementAgesAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const productRetirementAgesFeatureKey = 'productRetirementAges';

export interface ProductRetirementAgesState {
  productRetirementAgesResponse: IStaticDataResponse[];
  productRetirementAgesFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductRetirementAgesState = {
  productRetirementAgesFailure: undefined,
  productRetirementAgesResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductRetirementAgesAction.loadProductRetirementAges, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductRetirementAgesAction.loadProductRetirementAgesSuccess, (state, action) => ({
    ...state,
    productRetirementAgesResponse: action.response
  })),

  on(fromProductRetirementAgesAction.loadProductRetirementAgesFailure, (state, action) => ({
    ...state,
    productRetirementAgesFailure: action.error
  }))
);

export const getProductRetirementAgesResponse = (state: ProductRetirementAgesState) => state.productRetirementAgesResponse;
export const getProductRetirementAgesFailure = (state: ProductRetirementAgesState) => state.productRetirementAgesFailure;
export const getProductRetirementAgesIsLoaded = (state: ProductRetirementAgesState) => state.loaded;
